











































export default {
  props: ['experience'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    printLengthOfWork(startDate, endDate) {
      const start = new Date(startDate);
      const end = endDate ? new Date(endDate) : new Date();

      const monthDiff = end.getMonth() - start.getMonth() + 12 * (end.getFullYear() - start.getFullYear());
      return `(${Math.floor(monthDiff / 12)} Years ${monthDiff % 12} Months)`; //To take care of the case where start month is greater than end month
    },
  },
};
